











































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import EventApi from "../../../api/EventsApi";
import DraggableHtmlElement from "../../../libs/draggable-html-element/DraggableHtmlElement";
// @ts-ignore
import store from "../../../store";
// @ts-ignore
import Tools from "../../../helpers/Tools";
import {Player} from "../../../../types";

@Component({
    components: {},
    props: {}
})

export default class ToolsNotes extends Vue {
    @Prop({required: true}) private readonly coordinates!: {x: number, y: number};

    private colors: Array<string> = ['#ffffff', '#FFE500', '#F91E01', '#4CBB17', '#48FFC8', '#4870FF', '#C241FF'];
    private currentColor: string = this.colors[0];
    private panelInstance: DraggableHtmlElement|null = null;
    private newLeft: number = this.coordinates.x;
    private newTop: number = this.coordinates.y;
    private newMessageVisibleFor: Array<string> = [];

    mounted(): void
    {
        this.bindEvents();
        this.panelInstance = new DraggableHtmlElement(this.$refs.panel as HTMLElement);
    }

    beforeDestroy(): void
    {
        this.unbindEvents();
    }

    /**
     * ID игрока
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Данные игроков
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Позиция эл-та не менялась, находится в начальных координатах
     * @private
     */
    private get isInDefaultPosition(): boolean
    {
        return this.newLeft === parseInt(this.position.left)
            && this.newTop === parseInt(this.position.top);
    }

    /**
     * Позиционирование дайсомета в лейауте с ситами на столе
     * @private
     */
    private get position(): {[key: string]: string}
    {
        return {
            left: `${this.coordinates.x}px`,
            top: `${this.coordinates.y}px`
        }
    }

    private bindEvents(): void
    {
        (this.$refs.panel as HTMLElement).addEventListener('dragEnd', this.dragEnd);
    }

    private unbindEvents(): void
    {
        (this.$refs.panel as HTMLElement).removeEventListener('dragEnd', this.dragEnd);
    }

    /**
     * Изменить видимость нового сообщения для конкретных ситов
     * @param playerId - ID игрока
     */
    private toggleNewMessageVisibilityFor(playerId: string) {
        this.newMessageVisibleFor = Tools.toggleArrayElement(this.newMessageVisibleFor, playerId);
    }

    /**
     * Изменить видимость нового сообщения для всех ситов
     */
    private toggleNewMessageVisibilityAll(): void
    {

        if (this.newMessageVisibleFor.length > 1) {
            // Если видимо для кого-то кроме автора - выключаем видимость для всех, кроме автора
            this.newMessageVisibleFor = [this.playerId];
        } else {
            // Если видимо только автору - включаем видимость для всех
            const players = this.players;
            this.newMessageVisibleFor = players.map((el) => {
                return el.id;
            });
        }
    }

    /**
     * Закончили перетаскивание
     * @param e
     * @private
     */
    private dragEnd(e: any): void
    {
        this.newLeft = e.detail.left;
        this.newTop = e.detail.top;
    }

    /**
     * Закрыть панель
     * @private
     */
    private close(): void
    {
        this.$emit('close');
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
    }

    /**
     * Добавить заметку
     * @private
     */
    private addNote(): void
    {

    }

    /**
     * Изменить цвет
     * @param color
     * @private
     */
    private changeColor(color: string): void
    {
        this.currentColor = color;
    }
}

